import axios from 'axios';
import apiService from '../apiService';

export default async function checkIfGuestHasRegister(
  eventId = "",
  guestId = "",
) {
  try {
    const _ret = await axios({
      url: `${apiService.getUrl().externalBase}public/api/files/credenciamento/existeFace?IdEvento=${eventId}&IdParticipante=${guestId}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": apiService.getFaceRecognitionToken(),
      },
    });

    return _ret.data;
  } catch (error) {
    console.error("Error checkIfGuestHasRegister", error);
    throw error;
  }
}
